import React from "react";
import BlockUi from "react-block-ui";
import CalculatorApiTabs from "./CalculatorApiTabs";
import UsageFilters from "./UsageFilters";
import UsageSubTabs from "./UsageSubTabs";
import UsageTable from "./UsageTable";
import { useUsageTab } from "./useUsageTab";
import { clientLabelOf } from "../utils/clientLabel";
import { formatPeriod } from "../utils/formatPeriod";

// O corpo das sub-abas de consumo da Listagem. Cálculos e Consultas só trocam a
// rota chamada, o mapa de labels e o rótulo da coluna de quebra — o resto é
// idêntico, então mora aqui em vez de ser copiado em dois arquivos.
export default function UsageTab({ fetchUsage, labels, breakdownLabel }) {
  const {
    clients,
    clientsError,
    formFilters,
    appliedFilters,
    setFormFilters,
    applyFilters,
    usage,
    usageError,
    usageLoading,
    byClientRows,
    breakdownRows,
  } = useUsageTab({ fetchUsage, labels });

  const period = usage && formatPeriod(usage.period);

  return (
    <>
      <CalculatorApiTabs />
      <UsageSubTabs />

      <UsageFilters
        clients={clients}
        clientsError={clientsError}
        formFilters={formFilters}
        appliedFilters={appliedFilters}
        setFormFilters={setFormFilters}
        onApply={applyFilters}
      />

      {usageError && <div className="alert alert-warning">{usageError}</div>}

      <BlockUi tag="div" blocking={usageLoading}>
        {!usageError && !usage && (
          <p className="text-muted">Nenhum consumo via API B2B no período.</p>
        )}

        {!usageError && usage && (
          <>
            {period && (
              <p>
                Período apurado:{" "}
                <label className="badge badge-info">{period}</label>
              </p>
            )}

            {/* exatamente uma das duas dimensões vem: `client` quando há filtro
                de cliente, `byClient` no consolidado */}
            {usage.client && (
              <p>
                Cliente:{" "}
                <label className="badge badge-info">
                  {clientLabelOf(usage.client)}
                </label>
              </p>
            )}

            {usage.byClient && (
              <>
                <h4>Por cliente</h4>
                <UsageTable
                  rowLabel="Cliente"
                  rows={byClientRows}
                  totals={usage.totals}
                />
              </>
            )}

            <h4>Por {breakdownLabel.toLowerCase()}</h4>
            <UsageTable
              rowLabel={breakdownLabel}
              rows={breakdownRows}
              totals={usage.totals}
            />
          </>
        )}
      </BlockUi>
    </>
  );
}
